import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const Teams = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 2228.833 2073.333">
        <linearGradient
            id="teams-a"
            gradientTransform="matrix(1 0 0 -1 0 2075.3333)"
            gradientUnits="userSpaceOnUse"
            x1="198.099"
            x2="942.2344"
            y1="1683.0726"
            y2="394.2607"
        >
            <stop offset="0" stopColor="#5a62c3" />
            <stop offset=".5" stopColor="#4d55bd" />
            <stop offset="1" stopColor="#3940ab" />
        </linearGradient>
        <path
            d="m1554.637 777.5h575.713c54.391 0 98.483 44.092 98.483 98.483v524.398c0 199.901-162.051 361.952-361.952 361.952h-1.711c-199.901.028-361.975-162-362.004-361.901 0-.017 0-.034 0-.052v-571.409c.001-28.427 23.045-51.471 51.471-51.471z"
            fill="#5059c9"
        />
        <circle cx="1943.75" cy="440.583" fill="#5059c9" r="233.25" />
        <circle cx="1218.083" cy="336.917" fill="#7b83eb" r="336.917" />
        <path
            d="m1667.323 777.5h-950.313c-53.743 1.33-96.257 45.931-95.01 99.676v598.105c-7.505 322.519 247.657 590.16 570.167 598.053 322.51-7.893 577.671-275.534 570.167-598.053v-598.105c1.245-53.745-41.268-98.346-95.011-99.676z"
            fill="#7b83eb"
        />
        <path
            d="m1244 777.5v838.145c-.258 38.435-23.549 72.964-59.09 87.598-11.316 4.787-23.478 7.254-35.765 7.257h-481.532c-6.738-17.105-12.958-34.21-18.142-51.833-18.144-59.477-27.402-121.307-27.472-183.49v-598.157c-1.246-53.659 41.198-98.19 94.855-99.52z"
            opacity=".1"
        />
        <path
            d="m1192.167 777.5v889.978c-.002 12.287-2.47 24.449-7.257 35.765-14.634 35.541-49.163 58.833-87.598 59.09h-405.337c-8.812-17.105-17.105-34.21-24.362-51.833s-12.958-34.21-18.142-51.833c-18.144-59.476-27.402-121.307-27.472-183.49v-598.157c-1.246-53.659 41.198-98.19 94.855-99.52z"
            opacity=".2"
        />
        <path
            d="m1192.167 777.5v786.312c-.395 52.223-42.632 94.46-94.855 94.855h-447.84c-18.144-59.476-27.402-121.307-27.472-183.49v-598.157c-1.246-53.659 41.198-98.19 94.855-99.52z"
            opacity=".2"
        />
        <path
            d="m1140.333 777.5v786.312c-.395 52.223-42.632 94.46-94.855 94.855h-396.006c-18.144-59.476-27.402-121.307-27.472-183.49v-598.157c-1.246-53.659 41.198-98.19 94.855-99.52z"
            opacity=".2"
        />
        <path
            d="m1244 509.522v163.275c-8.812.518-17.105 1.037-25.917 1.037s-17.105-.518-25.917-1.037c-17.496-1.161-34.848-3.937-51.833-8.293-104.963-24.857-191.679-98.469-233.25-198.003-7.153-16.715-12.706-34.071-16.587-51.833h258.648c52.305.198 94.657 42.549 94.856 94.854z"
            opacity=".1"
        />
        <path
            d="m1192.167 561.355v111.442c-17.496-1.161-34.848-3.937-51.833-8.293-104.963-24.857-191.679-98.469-233.25-198.003h190.228c52.304.198 94.656 42.55 94.855 94.854z"
            opacity=".2"
        />
        <path
            d="m1192.167 561.355v111.442c-17.496-1.161-34.848-3.937-51.833-8.293-104.963-24.857-191.679-98.469-233.25-198.003h190.228c52.304.198 94.656 42.55 94.855 94.854z"
            opacity=".2"
        />
        <path
            d="m1140.333 561.355v103.148c-104.963-24.857-191.679-98.469-233.25-198.003h138.395c52.305.199 94.656 42.551 94.855 94.855z"
            opacity=".2"
        />
        <path
            d="m95.01 466.5h950.312c52.473 0 95.01 42.538 95.01 95.01v950.312c0 52.473-42.538 95.01-95.01 95.01h-950.312c-52.473 0-95.01-42.538-95.01-95.01v-950.312c0-52.472 42.538-95.01 95.01-95.01z"
            fill="url(#teams-a)"
        />
        <path
            d="m820.211 828.193h-189.97v517.297h-121.03v-517.297h-189.088v-100.349h500.088z"
            fill="#fff"
        />
    </SvgIcon>
);

export default Teams;
